export const updateItem = (list, i, newItem) => [...list.slice(0, i), newItem, ...list.slice(i + 1, list.length)];
export const addItem = (list, newItem) => list.concat(newItem);
export const removeItem = (list, i) => [...list.slice(0, i), ...list.slice(i + 1, list.length)];
export const reorderItemUp = (list, i) => {
  if (i < 1) throw new Error('Invalid index. Value must be greater than zero');
  return [...list.slice(0, i - 1), list[i], list[i - 1], ...list.slice(i + 1, list.length)];
};
